import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import './DateRangePicker.css'
import moment from "moment";

const DateRangePicker = ({ CallbackDate, range = "" }) => {
  // Calculate start and end of yesterday
  const startOfYesterday = moment().subtract(1, "days").startOf("day").toDate();
  const endOfYesterday = moment().subtract(1, "days").endOf("day").toDate();
  const [startDate, setStartDate] = useState(startOfYesterday);
  const [endDate, setEndDate] = useState(endOfYesterday);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const today = moment();
  const startOfLastMonth = today.clone().subtract(1, "months").startOf("month");
  const endOfLastMonth = today.clone().subtract(1, "months").endOf("month");

  const handleCustomSelection = (option) => {
    switch (option) {
      case "Today":
        setStartDate(today.toDate());
        setEndDate(today.toDate());
        break;
        
      case "Yesterday":
        setStartDate(startOfYesterday);
        setEndDate(endOfYesterday);
        break;

      case "This Week":
        setStartDate(today.startOf("week").toDate());
        setEndDate(today.endOf("week").toDate());
        break;

      case "Last 7 Days":
        setStartDate(today.clone().subtract(7, "days").toDate());  // 7 days ago from today
        setEndDate(today.toDate());  // today
        break;

      case "This Month":
        setStartDate(today.startOf("month").toDate());
        setEndDate(today.endOf("month").toDate());
        break;

      case "Last Month":
        setStartDate(startOfLastMonth.toDate());
        setEndDate(endOfLastMonth.toDate());
        break;

      default:
        break;
    }

    setIsDropdownVisible(false)
  };

  useEffect(() => {
    if (range) {
      handleCustomSelection(range); // Call custom selection when range changes
    }
  }, [range]);

  useEffect(() => {
    CallbackDate(startDate, endDate); // Callback with selected range
  }, [startDate, endDate]);

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
  };

  return (
    <div style={{ position: "relative", width: "200px" }}>
      {/* Input Field */}
      <div
        onClick={toggleDropdown}
        style={{
          cursor: "pointer",
          border: "1px solid #ccc",
          padding: "8px",
          borderRadius: "4px",
        }}
      >
        {startDate && endDate
          ? `${moment(startDate).format("dd/MM/yyyy")} - ${moment(
              endDate
            ).format("dd/MM/yyyy")}`
          : "Select a date range"}
      </div>

      {/* Dropdown */}
      {isDropdownVisible && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            zIndex: 10,
            display: "flex",
            width: "max-content",
          }}
        >
          {/* Custom Options as a List */}
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0,
              fontSize: "14px",
              width: "120px",
            }}
          >
            <li
              style={{ cursor: "pointer", padding: "8px", borderRadius: "4px" }}
              onClick={() => handleCustomSelection("Today")}
            >
              Today
            </li>
            <li
              style={{ cursor: "pointer", padding: "8px", borderRadius: "4px" }}
              onClick={() => handleCustomSelection("This Week")}
            >
              This Week
            </li>
            <li
              style={{ cursor: "pointer", padding: "8px", borderRadius: "4px" }}
              onClick={() => handleCustomSelection("Last 7 Days")}
            >
              Last 7 Days
            </li>
            <li
              style={{ cursor: "pointer", padding: "8px", borderRadius: "4px" }}
              onClick={() => handleCustomSelection("This Month")}
            >
              This Month
            </li>
            <li
              style={{ cursor: "pointer", padding: "8px", borderRadius: "4px" }}
              onClick={() => handleCustomSelection("Last Month")}
            >
              Last Month
            </li>
          </ul>

          {/* Date Range Picker */}
          <DatePicker
            selected={startDate}
            onChange={(dates) => {
              const [start, end] = dates;
              setStartDate(start);
              setEndDate(end);
            }}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
            monthsShown={2} // Show current and previous month
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
